import { createSlice } from '@reduxjs/toolkit';

import companyInitialState from './initialState';
import reducers from './reducers';

const companySlice = createSlice({
  name: '@company',
  initialState: companyInitialState,
  reducers,
});

export const companyActions = companySlice.actions;
export const companyReducers = companySlice.reducer;
